<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn v-if="locale!='ca'" class="mx-2" :color="getEvent.evenappprimarycolor" dark v-bind="attrs" v-on="on">
				{{ locale }}
			</v-btn>
			<v-btn v-else class="mx-2" :color="getEvent.evenappprimarycolor" dark v-bind="attrs" v-on="on">
				VA
			</v-btn>
		</template>
		<v-list dense>
			<v-list-item-group v-model="selectedIndex" :color="getEvent.evenappprimarycolor">
				<v-list-item v-for="(item, i) in localeList" :key="i">
					<v-list-item-content>
						<v-list-item-title class="text-center" v-if="item!='ca'" v-text="item" style="text-transform: uppercase;"></v-list-item-title>
						<v-list-item-title class="text-center" v-else v-text="'va'" style="text-transform: uppercase;"></v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	data() {
		return {
			selectedIndex: null,
			localeList: this.$i18n.availableLocales
		};
	},
	watch: {
		selectedIndex(val, beforeValue) {
			if (val !== undefined) {
				this.$i18n.locale = this.locale;
				this.SET_LANG(this.locale);

				if ((beforeValue !== undefined) & (beforeValue !== null)) {
					window.localStorage.setItem('FV_LANG', this.locale);
					this.$router.go();
				}
			} else {
				this.selectedIndex = beforeValue;
				this.$i18n.locale = this.localeList[beforeValue];
			}
		}
	},
	methods: {
		...mapActions(['SET_LANG', 'EMPTY_ALL_SELECTED_TICKETS', 'SET_ACTIVE_PANEL'])
	},
	computed: {
		...mapGetters(['getEvent']),
		locale() {
			return this.localeList[this.selectedIndex];
		}
	},
	mounted() {
		const selectedLang = this.$i18n.locale || 'es';
		this.selectedIndex = this.localeList.findIndex((locale) => locale === selectedLang);
	}
};
</script>

<style></style>
